module.exports = __webpack_public_path__ + "media/images/icons/flags/AR-feb0a193ced31848549c7fcc3508172b.svg";